import { render, staticRenderFns } from "./Chamado.vue?vue&type=template&id=12a25c62&"
import script from "./Chamado.vue?vue&type=script&lang=js&"
export * from "./Chamado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports